<template>
  <div class="flex flex-col rounded border border-gray-divider text-left px-4 pb-4 md:pb-3 pt-2  bg-white-high-emphasis text-xs tracking-wide leading-4">
    <!-- Logo -->
    <img
      :alt="content.logo.alt"
      :src="content.logo.source"
      class="h-8 mr-auto"
    />
    <!-- Message -->
    <p class="text-gray-darkest mt-2 mb-4" data-testid="offer-description">
      {{ content.description }}
    </p>
    <div class="flex mt-auto gap-6 text-black-medium-emphasis underline">
      <!-- Link -->
      <a
        :href="content.getOfferUrl"
        target="_parent"
        class="hover:text-black-high-emphasis"
        :aria-label="content.getOfferText"
        @click.prevent="onGetOfferClick">
        {{ content.getOfferText }}
      </a>
      <!-- Expiration date -->
      <p data-testid="expiration-info">{{ content.expiresLabel }} {{ expiresDate }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Offer } from '@/model'
import { trackEvent } from '@/utils/analytics'
import { formatDate } from '@/utils/date'
import { addAdobeDataLayerEventGetOffer } from '@/utils/adobe-analytics-data-layer'
export default defineComponent({
  props: {
    content: {
      type: Object as () => Offer,
      required: true,
      validator: (value: Offer) => value instanceof Offer
    }
  },
  setup (props) {
    function onGetOfferClick () {
      addAdobeDataLayerEventGetOffer()
      window.open(props.content.getOfferUrl, '_parent')
    }

    return { onGetOfferClick, expiresDate: formatDate(props.content.expiresDate) }
  }
})
</script>
